import { defineComponent as _defineComponent } from 'vue'
import AreaSelector from '@/components/area-selector/area-selector.component.vue'
import { CustomerTypeOptions, LibType } from '@/consts'

import store from '../lib.store'
import LibRefGroup from '../shared/lib-ref-group.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'base-form',
  setup(__props, { expose }) {

const BaseRequired = { required: true, message: '请填写' }

const edit = store.edit

const rules = {
  name: [BaseRequired],
  phone: [BaseRequired],
  customer_type: [{ ...BaseRequired, message: '请选择' }],
  lib_type: [{ ...BaseRequired, message: '请选择' }],
  open_type: [{ ...BaseRequired, message: '请选择' }],
  area: [{ ...BaseRequired, type: 'array', message: '请选择' }]
}

// Export
function getForm() {
  return this.$refs.form
}
expose({ getForm })

return { __sfc: true,BaseRequired, edit, rules, getForm, AreaSelector, CustomerTypeOptions, LibType, LibRefGroup }
}

})